import { Text } from '@/ui';
import styles from './styles.module.css';
import { Column, Row } from '../SettingsLayout';
import { useTranslation } from 'react-i18next';
import { Company } from '@/context/types';
import { TBuild } from '@/types';
export type FakeBuild = {
  _id: string;
  name: string;
  description: string;
  version: string;
  isPublished: boolean;
};
type Props = {
  build: TBuild;
  organization: Company;
};

function CheckoutFlowCard({ build, organization }: Props) {
  const { t } = useTranslation();
  return (
    <div className={styles.checkoutCard}>
      <div className={styles.checkoutImg}>
        <img src='/cardIcon.png' alt='cardImage' height={112} />
      </div>
      <Column gapSize='8' fullWidth>
        <Column gapSize='4' fullWidth>
          <Row fullWidth justify='justify-between'>
            <Text size='m' weight='light-medium'>
              {build.name}
            </Text>
            <Text size='xxs' weight='light-medium'>
              {build.isPublished ? t('Build.published') : t('Build.draft')}
            </Text>
          </Row>
          <Row fullWidth justify='justify-between'>
            <Text size='xs' weight='light-medium'>
              {build.description ?? ''}
            </Text>
            <div className={styles.versionContainer}>
              <Text size='xxs' weight='light-medium'>
                {build.version}
              </Text>
            </div>
          </Row>
        </Column>
        <Row fullWidth gapSize='8'>
          {organization?.logo && <div className={styles.orgLogo}></div>}
          <Text size='xs' weight='light-medium' color='base-grey'>
            {organization?.name}
          </Text>
        </Row>
      </Column>
    </div>
  );
}

export default CheckoutFlowCard;
